import { render, staticRenderFns } from "./preview-image.vue?vue&type=template&id=644fa092&scoped=true"
import script from "./preview-image.vue?vue&type=script&lang=js"
export * from "./preview-image.vue?vue&type=script&lang=js"
import style0 from "./preview-image.vue?vue&type=style&index=0&id=644fa092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fa092",
  null
  
)

export default component.exports